import { Record } from 'immutable';
import EmptyList from './EmptyList';
import PwrCloudinary from 'lib/pwr-cloudinary';

const stripProtocol = url => url.replace(/http(s)?:/, '');

const ImageRecord = Record({
  ugc_id: null,
  parent_ugc_id: null,
  ugctype: 'Image',
  ugcsubtype: null,
  ugc_archetype: '',
  subject_id: null,
  created_date: null,
  updated_date: null,
  author: '',
  location: '',
  email: '',
  email_confirm_status: '',
  source: '',
  ip_address: '',
  device_id: '',
  url: '',
  urlSet: {},
  thumbnail_url: '',
  caption: '',
  locale: '',
  published: null,
  ugc_related_content: EmptyList,
  featured: false,
});

export default class Image extends ImageRecord {
  static createWithData(data) {
    const url = stripProtocol(data.url || data.thumbnail_url || '');
    const urlSet = PwrCloudinary.libraryUrlSet(url);

    return new Image({
      ...data,
      url,
      urlSet,
    });
  }

  getReview() {
    return this.ugc_related_content.find(ugc => ugc.ugc_archetype === 'Review');
  }
}



// WEBPACK FOOTER //
// ./src/models/Image.js